function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Button } from '@finect/tabular-core/Button';
import { Datalayer } from '@finect/front-gtm';
import { Link } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { Wrapper as ReviewsSummaryWrapper } from '../ReviewsSummary/Wrapper';
import { ReviewCardList } from '../ReviewCardList';
import { getReviewsPath, getWriteReviewPath } from '../../Reviews/utils';
import { Select } from '../../Select';
import { Loading } from '../../Loading';
import { NoResultsPlaceholder } from '../../Questions';
import { Inner, MoreButton, ContentBlock, FilterBlock, Filters, OrdersBy, Aside, Content, ResetButton, EmptyResults } from './partials';
import { PlaceholderReviewsIcon } from './icons';
import { orderOptions } from './utils';
export var ReviewsBlock = function (_React$Component) {
  _inherits(ReviewsBlock, _React$Component);
  var _super = _createSuper(ReviewsBlock);
  function ReviewsBlock() {
    var _this;
    _classCallCheck(this, ReviewsBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      reviews: [],
      paging: {
        limit: 0,
        totalItems: 0
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      var _this$props$actions;
      (_this$props$actions = _this.props.actions) === null || _this$props$actions === void 0 ? void 0 : _this$props$actions.getProductReviews(_this.props.reviews.request);
    });
    _defineProperty(_assertThisInitialized(_this), "handleScoreChange", function (option) {
      var _this$props$actions2;
      var newParams = _objectSpread(_objectSpread({}, _this.props.reviews.request), {
        score: option.id
      });
      (_this$props$actions2 = _this.props.actions) === null || _this$props$actions2 === void 0 ? void 0 : _this$props$actions2.getProductReviews(newParams);
    });
    _defineProperty(_assertThisInitialized(_this), "handleOrderByChange", function (option) {
      var _this$props$actions3;
      var newParams = _objectSpread(_objectSpread({}, _this.props.reviews.request), {
        orderBy: option.id
      });
      (_this$props$actions3 = _this.props.actions) === null || _this$props$actions3 === void 0 ? void 0 : _this$props$actions3.getProductReviews(newParams);
    });
    return _this;
  }
  _createClass(ReviewsBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        product = _this$props.product,
        me = _this$props.me,
        qty = _this$props.qty,
        showMoreButton = _this$props.showMoreButton,
        finectApp = _this$props.finectApp,
        theme = _this$props.theme;
      var path = getReviewsPath(theme, product);
      var writePath = getWriteReviewPath(theme, product);
      var _this$props$reviews = this.props.reviews,
        _this$props$reviews$i = _this$props$reviews.items,
        items = _this$props$reviews$i === void 0 ? [] : _this$props$reviews$i,
        _this$props$reviews$r = _this$props$reviews.request,
        request = _this$props$reviews$r === void 0 ? {} : _this$props$reviews$r,
        _this$props$reviews$f = _this$props$reviews.fetching,
        fetching = _this$props$reviews$f === void 0 ? true : _this$props$reviews$f,
        _this$props$reviews$f2 = _this$props$reviews.fetched,
        fetched = _this$props$reviews$f2 === void 0 ? true : _this$props$reviews$f2,
        paging = _this$props$reviews.paging;
      var score = request.score,
        orderBy = request.orderBy;
      var displayItems = showMoreButton ? items.slice(0, qty) : items;
      var moreButtonProps = ['front-products'].includes(finectApp) && path.pattern.match ? {
        as: Link,
        to: path.path,
        rel: 'nofollow'
      } : {
        as: 'a',
        href: path.superPartnerURL,
        rel: 'nofollow'
      };
      if (items.length === 0 && !score) {
        return React.createElement(Inner, null, React.createElement(NoResultsPlaceholder, {
          product: product,
          link: {
            href: "".concat(writePath.pattern.match ? writePath.path : writePath.superPartnerURL),
            text: 'Escribe tu opinión',
            'data-fi-event': 'productReviews-review'
          },
          text: React.createElement("span", null, "Este producto a\xFAn no ha recibido ninguna opini\xF3n. ", React.createElement("b", null, "S\xE9 el primero en escribir"), " la tuya para ayudar al resto de usuarios a tomar mejores decisiones financieras."),
          icon: PlaceholderReviewsIcon
        }));
      }
      return React.createElement(Inner, null, React.createElement(Datalayer, {
        id: "Reviews",
        type: "impressions",
        params: {
          models: displayItems
        }
      }), React.createElement(FilterBlock, null, React.createElement(Filters, null, React.createElement(Select, {
        onChange: this.handleScoreChange,
        selected: score,
        options: [1, 2, 3, 4, 5].reverse().map(function (value) {
          return {
            id: value,
            label: "".concat(value, " estrella").concat(value > 1 ? 's' : '')
          };
        }),
        placeholder: "Valoraci\xF3n"
      }), score ? React.createElement(ResetButton, {
        width: "auto",
        onClick: this.handleReset
      }, "Restablecer") : null), React.createElement(OrdersBy, null, React.createElement(Select, {
        onChange: this.handleOrderByChange,
        selected: orderBy,
        options: orderOptions
      }))), React.createElement(ContentBlock, null, !this.props.asideHidden ? React.createElement(Aside, null, React.createElement(ReviewsSummaryWrapper, {
        product: product,
        me: me
      })) : null, React.createElement(Content, {
        centered: items.length === 0
      }, fetching ? React.createElement(Fragment, null, React.createElement(Loading, null)) : React.createElement(Fragment, null, displayItems.length ? React.createElement(ReviewCardList, {
        finectApp: finectApp,
        product: product,
        me: me,
        reviews: displayItems,
        tag: this.props.tag || null
      }) : React.createElement(EmptyResults, null, React.createElement("div", null, React.createElement(Paragraph, null, "No hemos encontrado valoraciones de ", score, " estrella", score > 1 ? 's ' : ' ', "para ", React.createElement("strong", null, this.props.product.name)), React.createElement(Button, {
        as: "a",
        href: "/nueva-review",
        rel: "nofollow",
        width: "auto"
      }, "Escribe tu opini\xF3n"))), showMoreButton && items.length > displayItems.length ? React.createElement(MoreButton, _extends({
        title: "Ver m\xE1s reviews de ".concat(product.name),
        width: "auto"
      }, moreButtonProps), "Ver todas las opiniones", React.createElement(ArrowRight, {
        size: 18
      })) : null))));
    }
  }]);
  return ReviewsBlock;
}(React.Component);
export default React.memo(withTheme(ReviewsBlock));